import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import { IDateRange } from '../analytics.types';
import { getUsersAnalyticsApi } from '../analyticsApi';
import { normalizeUsersAnalyticsResponse } from '../analyticsUtils';
import { RootState } from '../../../store';

const GET_USERS_ANALYTICS = 'analytics/getUsersAnalytics';

export interface IOrganizationWiseUsersItem {
  orgId: string;
  users: number;
}

interface IUsersAnalyticsState {
  status: string;
  error: string | null;
  totalUsersCount: number;
  organizationWiseUsers: IOrganizationWiseUsersItem[];
}

const initialState: IUsersAnalyticsState = {
  status: Status.IDLE,
  error: null,
  totalUsersCount: 0,
  organizationWiseUsers: [],
};

export const getUsersAnalytics = createAsyncThunk(
  GET_USERS_ANALYTICS,
  async () => {
    const usersAnalyticsResponse = await getUsersAnalyticsApi();
    return normalizeUsersAnalyticsResponse(usersAnalyticsResponse);
  }
);

const usersAnalyticsSlice = createSlice({
  name: 'usersAnalytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsersAnalytics.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(getUsersAnalytics.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.error = null;
        state.totalUsersCount = action.payload.totalUsersCount;
        state.organizationWiseUsers = action.payload.organizationWiseUsers;
      })
      .addCase(getUsersAnalytics.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || 'Failed to fetch users analytics.';
      });
  },
});

export const selector = (state: RootState) => state.usersAnalytics;

export default usersAnalyticsSlice.reducer;